export default __webpack_public_path__ + "static/media/income-tax-department.f7058c75.svg";